import React, { useEffect, useState } from 'react';

import {
	DeliverSuccessfull,
	DeliveryDoneByAnotherDriver,
	DeliveryErrorMessages,
	MissedDeliveryErrorMessages,
	PickedUpSuccessfully,
} from '../../components/common/AllConfirmationMessages';

import { PatientDetails, VideoCallButton } from '../../components/common/patientDetails';
import PatientHandoverSheet from '../../components/common/patientHandoverSheet';

import {
	MissedDeliveryConfirmation,
	RouteConfirmation
} from '../../components/common/routeConfirmation';

import {
	apiKey,
	deliveryDriverDeliveredDispense
} from '../../networking/urlEndPoints';

import {
	clearAllTodayDispenseData,
	removeTodayDispenePatientById,
	todayDispenseRemovingPageNumber
} from '../../services/slices/dispense/patientForRouteList';

import {
	flexiNotificationRxNumbers,
	onhandleConfirmDelivery,
	onhandleMissedDelivery
} from '../../utils/helper/deliveriesHelper';

import { clearConfirmDeliveryUserMessage } from '../../services/slices/dispense/confirmDelivery';
import { clearUpdateDeliveryUserMessage } from '../../services/slices/dispense/updateDeliveryStatus';

import SortOptionMenu from '../../components/common/SortOptionMenu';
import DriverAppointmentCallPanel from '../../components/common/driverAppointmentCallPanel';
import { fetchPatientlistOnBasisOfRoute } from '../../services/apis/dispense/patientsForRouteLIst';
import { DELIVERY_SORT_OPTIONS } from '../../utils/helper/sortUi';
import { openDeliveryPatientOnSignPage } from '../../utils/constants/deliveryPrivacy';
import { fetchTodayMissed } from '../../services/apis/dispense/todayMissed';
import { useAllSelector } from '../../services/selectors/allSelector';

import { LoadingView, Loader } from '../../components/common/loader';
import { ErrorMessages } from '../../components/error/errorMessages';

import { DispenseRxData } from '../../components/common/dispenseRxData';
import { handleToggleRXData, refreshCurrentLocation } from '../../utils/helper/helper';
import { useCustomStates } from '../../hooks/useCustomStates';

import { useAuthSelector } from '../../services/selectors/authSelector';
import { RoutePharmacistModal } from '../../components/common/routePharmacistModal';
import { RouteControlSheet } from '../../components/common/routeControlSheet';
import { TAB } from '../../components/common/routeControlSheet/constants';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { TodayDispenseDeliveredByAnotherDriverAblyHelper } from '../../utils/helper/ablyDeliveredDispenseByOthers';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';
import Cookies from 'js-cookie';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as routeName from '../../routes/routeName';
// import { FlexiRxStatusWarningModal } from '../../components/common/rxStatusWarningModal';
import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';

const TodayDispense = () => {

	const dispatch = Hooks.useCustomDispatch();
	const navigate = Hooks.useCustomNavigate();

	const location = Hooks.useCustomLocation()
	const [showRouteHandover, setShowRouteHandover] = useState(false);

	const routeId = new URLSearchParams(location.search).get('route')
	const pickRoute = Cookies.get('td')

	const { pharmacyId,
		driverID,
		pharmacyInspectionMode } = useAuthSelector()

	const { patientDataBasisOfRouteResponse,
		todayMissedListResponse,
		todaysDispenseList,
		validateReturnedPatchesResponse,
		todayMissedList,
		pharmacist_assistant_status,
		confirmDeliveryResponse,
		updateDeliveryListResponse,
	} = useAllSelector();

	const { flexiMarkedNotificationsResponse } = useSuperVisorSelector()


	const { comment,
		setComment,

		cordinate,
		setCordinate,

		openIndex,
		setOpenIndex,

		isRefused,
		setIsRefused,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		loading,
		setLoading,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showPharmacistSignature,
		setShowPharmacistSignature,

		showData,
		setShowData,

		showToast,
		setShowToast,

		showConfirmationModal,
		setShowConfirmationModal,

		setMissedDeliveryErrorToast,
		missedDeliverErrorToast,

		missedDeliveryConfirmation,
		setMissedDeliveryConfirmation,

		missedData,
		setMissedData,

		missedExplanation,
		setMissedExplanation,

		missedExplanationError,
		setMissedExplanationError,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		selectedRoute,
		setSelectedRoute,

		isTransferRequest,
		setIsTransferRequest,

		loadMore,
		setLoadMore,

		delveryDoneByAnotherDriver,
		setDeliveryDoneByAnotherDriver,

		missedIndex,
		setMissedIndex,

		patientId,
		setPatientID,

		pId,
		setPId,

		showModel,
		setShowModel,

		pickupRoute,
		setPickupRoute,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses,

		unconsumedDoseEntries,
		setUnconsumedDoseEntries,

		unconsumedDoseErrors,
		setUnconsumedDoseErrors

	} = useCustomStates()

	const [flexiProofImages, setFlexiProofImages] = useState({})
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({})

	const [showFlexiConfirmation, setShowFlexiConfirmation] = useState(false)
	const [flexiRxNumbers, setFlexiRxNumbers] = useState([])
	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])
	const [deliverySort, setDeliverySort] = useState('default')
	const { getMatchedAppointmentDelivery } = Hooks.useTodayAppointmentDeliveryMap({
		pharmacyId,
		enabled: Boolean(
			selectedRoute &&
			pharmacyId &&
			!patientDataBasisOfRouteResponse?.loading &&
			Array.isArray(todaysDispenseList) &&
			todaysDispenseList.length > 0
		),
		refreshKey: `${selectedRoute}:${deliverySort}`,
	})

	const handleDropdownToggle = (index, data) => {
		if (openDeliveryPatientOnSignPage(navigate, data)) {
			return;
		}

		setConsultation(null)
		setNewRxCounsellingValues([])
		setSelectedDoses({})
		setFlexiRxNumbers(data?.patients_win_rx_data)
		if (openIndex !== index) {
			refreshCurrentLocation(setCordinate)
			const rxIds = data?.patients_win_rx_data?.map((r) => r.id).filter(Boolean) || []
			setSelectedDeliverRxIds(rxIds)
		}
		handleToggleRXData(
			index,
			data,
			openIndex,
			setOpenIndex,
			dispatch,
			setSignatureErrors,
			setShowData,
			RemoveAllPatchesId,
			setPatientSignature,
			setShowComment,
			setShowPatientSignature,
			setShowPharmacistSignature,
			setPharmacistSignature,
			setComment,
			setIsPatientVerified,
			setUnconsumedDoseEntries,
			setUnconsumedDoseErrors,
			setMissedExplanation,
			setMissedExplanationError,
			setPId,
			pharmacyId
		);
	};

	useEffect(() => {
		if (selectedRoute && pharmacyId) {
			const params = {
				route: selectedRoute,
				pharmacy_id: pharmacyId,
				delivery_sort: deliverySort,
				setLoading: setLoading,
			}
			dispatch(clearAllTodayDispenseData())
			dispatch(todayDispenseRemovingPageNumber())
			setLoading(true)
			dispatch(fetchPatientlistOnBasisOfRoute(params))
		}
		return () => { }
	}, [selectedRoute, deliverySort])

	useEffect(() => {
		setSelectedRoute(routeId)
		return () => { }
	}, [routeId])

	// Fetch today missed list when today dispense page loads
	useEffect(() => {
		if (pharmacyId) {
			dispatch(fetchTodayMissed({ pharmacy_id: pharmacyId, status: 'today_missed' }))
		}
		return () => { }
	}, [pharmacyId,dispatch])

	const handleConfirmDelivery = (patientData, index) => {

		// const matchedFlexiData = flexiNotificationRxNumbers(flexiMarkedNotificationsResponse,
		// 	patientData?.patients_win_rx_data, patientData.id)
		// if (matchedFlexiData && matchedFlexiData.length > 0) {
		// 	setFlexiRxNumbers(matchedFlexiData);
		// 	setShowFlexiConfirmation(true);
		// 	return;
		// }

		onhandleConfirmDelivery(patientData,
			index,
			pharmacyId,
			null,
			patientSignature,
			pharmacistSignature,
			cordinate,
			comment,
			dispatch,
			setLoading,
			setOpenIndex,
			setShowErrorToast,
			setShowSuccessToast,
			pharmacyInspectionMode,
			isRefused,
			covid19,
			'today_dispense',
			setIsRefused,
			setSignatureErrors,
			validateReturnedPatchesResponse,
			isTransferRequest,
			setIsTransferRequest,
			pharmacist_assistant_status,
			consultation,
			newRxCounsellingValues,
			selectedDoses,
			flexiProofImages,
			copayPaymentOptions,
			null,
			isPatientVerified,
			selectedDeliverRxIds,
			unconsumedDoseEntries,
			setUnconsumedDoseErrors
		);
	}

	useEffect(() => {
		const matchedFlexiData = flexiNotificationRxNumbers(flexiMarkedNotificationsResponse, flexiRxNumbers, pId)
		if (matchedFlexiData && matchedFlexiData.length > 0) {
			setShowFlexiConfirmation(true);
		} else {
			setShowFlexiConfirmation(false);
		}
		return () => { }
	}, [pId, flexiRxNumbers, flexiMarkedNotificationsResponse])

	const handleMissedDelivery = () => {
		onhandleMissedDelivery(pharmacyId,
			missedData,
			missedIndex,
			dispatch,
			setOpenIndex,
			setMissedDeliveryErrorToast,
			setMissedDeliveryConfirmation,
			missedExplanation,
			setMissedExplanation,
			setMissedExplanationError,
			"today_missed",
			"today_dispense",
			selectedDoses,
			selectedDeliverRxIds,
			cordinate)
	}

	const fetchMoreData = () => {
		if (patientDataBasisOfRouteResponse?.currentPage < patientDataBasisOfRouteResponse?.totalPages) {
			setLoadMore(true)
			if (selectedRoute && pharmacyId) {
				const params = {
					route: selectedRoute,
					pharmacy_id: pharmacyId,
					page: patientDataBasisOfRouteResponse?.currentPage + 1,
					delivery_sort: deliverySort,
					setLoadMore: setLoadMore
				}
				setLoading(false)
				dispatch(fetchPatientlistOnBasisOfRoute(params))
			}
		}
	}

	const refreshTodayDispense = () => {
		if (!selectedRoute || !pharmacyId || patientDataBasisOfRouteResponse?.loading) return
		setOpenIndex(null)
		setLoading(true)
		dispatch(clearAllTodayDispenseData())
		dispatch(todayDispenseRemovingPageNumber())
		dispatch(fetchPatientlistOnBasisOfRoute({
			route: selectedRoute,
			pharmacy_id: pharmacyId,
			page: 1,
			delivery_sort: deliverySort,
			setLoading
		}))
	}


	useEffect(() => {
		setTimeout(() => {
			Cookies.set('td', false)
		}, 2000);
		return () => { }
	}, [patientDataBasisOfRouteResponse])

	useEffect(() => {
		setPickupRoute(pickRoute)
		return () => { }
	}, [pickRoute])

	useEffect(() => {
		if (patientDataBasisOfRouteResponse?.loading) {
			setShowModel(false)
		} else if (patientDataBasisOfRouteResponse?.data?.length === 0) {
			setShowModel(true)
		} else {
			setShowModel(false)
		}
	}, [patientDataBasisOfRouteResponse])

	const hasTodayMissedMedication =
		!todayMissedListResponse?.loading &&
		todayMissedListResponse?.error === null &&
		Array.isArray(todayMissedList) &&
		todayMissedList.some((patient) =>
			Array.isArray(patient?.patients_win_rx_data_today_missed) &&
			patient.patients_win_rx_data_today_missed.length > 0
		)

	return (
		<>
			{patientDataBasisOfRouteResponse?.data?.length > 0 &&
				<InfiniteScroll
					dataLength={patientDataBasisOfRouteResponse?.data?.length}
					next={fetchMoreData}
					hasMore={patientDataBasisOfRouteResponse?.currentPage <= patientDataBasisOfRouteResponse?.totalPages}
				/>
			}

			<div className="app-wrapper flex justify-center">
				<div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden ">
					<div className="relative p-4">
						<Common.TopBar />

						<div className="title-row my-2 flex items-center justify-between gap-2">
							<h1 className="text-xl font-bold">{selectedRoute} Dispense List</h1>
							<div className="flex items-center gap-2">
								<button
									type="button"
									onClick={() => setShowRouteHandover(true)}
									className="inline-flex h-9 items-center justify-center gap-0.5 rounded-md border border-indigo-200 bg-indigo-50 px-2 text-[11px] font-semibold text-indigo-700 transition-colors hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-300 active:bg-indigo-200"
								>
									<Icons.SendIcon className="h-2.5 w-2.5" />
									<span>Hand over route</span>
								</button>
								<SortOptionMenu
									options={DELIVERY_SORT_OPTIONS}
									value={deliverySort}
									onChange={setDeliverySort}
									ariaLabel="Delivery sorting"
								/>
							</div>
						</div>

						<div className='flex'>
							{hasTodayMissedMedication &&
								<button onClick={() => navigate(`${routeName.Missed_Route}`)}
									className="p-4 mb-3 mr-2 h-10 flex items-center justify-center text-sm font-medium  text-white w-full rounded-lg"
									style={{ backgroundColor: '#c12323' }}>Missed Bag</button>
							}

							<button className="p-4 mb-3 h-10 flex items-center justify-center text-sm font-medium text-white w-full rounded-lg"
								style={{ backgroundColor: '#FEAE02' }} onClick={() => navigate(`${routeName.driver_today_pending}`)}>
								Pending Bag
							</button>
						</div>

						<div className="flex gap-3 mb-3">
							<SearchBox pharmacyId={pharmacyId} onRefresh={refreshTodayDispense} isRefreshing={patientDataBasisOfRouteResponse?.loading && loading} />
						</div>

						<div className="routes-list">
							{(patientDataBasisOfRouteResponse?.loading && loading) ?

								<div className='flex justify-center pb-4 h-96'>
									<LoadingView />
								</div> :

								patientDataBasisOfRouteResponse?.error !== null ?

									<div className='flex items-center justify-center pb-4 mb-4 h-96'>
										<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
									</div> :

									(todaysDispenseList?.length === 0 && !patientDataBasisOfRouteResponse?.loading) ?
										<p className='flex justify-center pb-4 h-96'>
											All Deliveries Done for this Route.
										</p>
										:

										todaysDispenseList?.map((data, index) => {
											const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
											const isRouteAllowed = data.route_access?.allowed !== false;
											const appointmentDelivery = isRouteAllowed ? getMatchedAppointmentDelivery(data) : null;
											return (
											<React.Fragment key={index}>

												<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
													<PatientDetails
														data={data}
														patientImg={data.profile_image}
														totalRxData={data?.patients_win_rx_data?.length}
														index={index}
															openIndex={openIndex}
															onDropdownToggle={handleDropdownToggle}
															headerAction={<PatientHandoverSheet patient={data} eligible={isRouteAllowed && data?.delivery_status !== 'delivered'} />}
														>
													<>
															<DispenseRxData
																newRxCounsellingValues={newRxCounsellingValues}
																setNewRxCounsellingValues={setNewRxCounsellingValues}
																rxData={data?.patients_win_rx_data}
																patientData={data}
																selectedDoses={selectedDoses}
																setSelectedDoses={setSelectedDoses}
																type="new_rx"
																flexiProofImages={flexiProofImages}
																setFlexiProofImages={setFlexiProofImages}
																copayPaymentOptions={copayPaymentOptions}
																setCopayPaymentOptions={setCopayPaymentOptions}
																selectedDeliverRxIds={selectedDeliverRxIds}
																setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																unconsumedDoseEntries={unconsumedDoseEntries}
																setUnconsumedDoseEntries={setUnconsumedDoseEntries}
																unconsumedDoseErrors={unconsumedDoseErrors}
																setUnconsumedDoseErrors={setUnconsumedDoseErrors}
																isActiveDeliverRxCard={openIndex === index} />

															{patientId !== data?.id ? <>

																{showData &&
																	<React.Fragment>
																		<Common.Comment
																			showComment={showComment}
																			setShowComment={setShowComment}
																			setComment={setComment} comment={comment} />

																		<Common.DeliveryConsultationDropdown consultation={consultation}
																			setConsultation={setConsultation} />

																		<Common.PatientSignature
																			patientSignature={patientSignature}
																			setPatientSignature={setPatientSignature}
																			showPatientSignature={showPatientSignature}
																			setShowPatientSignature={setShowPatientSignature}
																			isRefused={isRefused}
																			setIsRefused={setIsRefused}
																			isPatientVerified={isPatientVerified}
																			setIsPatientVerified={setIsPatientVerified}
																			signatureErrors={signatureErrors}
																			setSignatureErrors={setSignatureErrors}
																			covid19={covid19}
																			setCovid19={setCovid19}
																			rxData={data?.patients_win_rx_data}
																		/>

																		{pharmacist_assistant_status === 1 ? null :
																			<Common.PharmacistSignature
																				pharmacistSignature={pharmacistSignature}
																				setPharmacistSignature={setPharmacistSignature}
																				showPharmacistSignature={showPharmacistSignature}
																				setShowPharmacistSignature={setShowPharmacistSignature}
																				signatureErrors={signatureErrors}
																				setSignatureErrors={setSignatureErrors}
																			/>}


																	</React.Fragment>
																}

																{!isRouteAllowed && (
																	<div className="mb-3 rounded-lg border border-red-200 bg-red-50 px-3 py-3 text-sm text-red-700">
																		<p className="font-semibold">Delivery blocked for this patient.</p>
																		<p>{data?.route_access?.reason || 'This patient has been handed over to another user.'}</p>
																		{data?.assigned_route_owner?.name ? (
																			<p className="mt-1 text-xs text-red-600">Assigned user: {data.assigned_route_owner.name}</p>
																		) : null}
																	</div>
																)}

																<div className="flex items-center gap-2">
																	<VideoCallButton
																		data={data}
																		variant="cta"
																		disabled={noRxSelected || !isRouteAllowed}
																		label="Video call"
																	/>

																	{!showData &&
																		<button
																			className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-red-500 text-white'}`}
																			disabled={noRxSelected || !isRouteAllowed}
																			onClick={() => {
																				if (noRxSelected || !isRouteAllowed) return;
																				setMissedData(data);
																				setMissedIndex(index);
																				setMissedExplanation('');
																				setMissedExplanationError('');
																				setMissedDeliveryConfirmation(true);
																			}}>
																			<p className='flex justify-center items-center'>
																				Missed</p>
																		</button>}

																	{showData ?
																		

																			showFlexiConfirmation ?
																				<button
																					className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md"
																					onClick={() => {
																						window.location.reload();
																					}}
																				>
																					Reload
																				</button>
																				:

																				<button
																					className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																					disabled={noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading}
																					onClick={() => {
																						if (noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading) return;
																						handleConfirmDelivery(data, index);
																					}}>
																					{confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loader /></p> : 'Continue'}
																				</button>
																		:
																		<button
																			className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																			disabled={noRxSelected || !isRouteAllowed}
																			onClick={() => {
																				if (noRxSelected || !isRouteAllowed) return;
																				setShowData(true);
																				setTimeout(() => {
																					const windowHeight = window.innerHeight;
																					const scrollAmount = windowHeight / 2;
																					window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																				}, 100);
																			}}
																		>
																			Deliver
																		</button>}

																</div> </> : null}
													</>
													</PatientDetails>
													{appointmentDelivery ? (
														<DriverAppointmentCallPanel
															patient={data}
															appointmentDelivery={appointmentDelivery}
														/>
													) : null}
												</div>
											</React.Fragment>);
										})}
						</div>

						{loadMore &&
							<div className='flex mb-2'>
								<div className="loaderss"></div>
							</div>}

					</div>

					{(patientDataBasisOfRouteResponse?.loading && loading && pickupRoute === 'true') && <PickedUpSuccessfully setShowToast={setShowToast} />}
					{showErrorToast && (
						<DeliveryErrorMessages
							setShowErrorToast={setShowErrorToast}
							message={confirmDeliveryResponse?.userFacingErrorMessage}
							onDismiss={() => dispatch(clearConfirmDeliveryUserMessage())}
						/>
					)}
					{showSuccessToast && <DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}
					{missedDeliverErrorToast && (
						<MissedDeliveryErrorMessages
							setMissedDeliveryErrorToast={setMissedDeliveryErrorToast}
							message={updateDeliveryListResponse?.userFacingErrorMessage}
							onDismiss={() => dispatch(clearUpdateDeliveryUserMessage())}
						/>
					)}
					{delveryDoneByAnotherDriver && <DeliveryDoneByAnotherDriver setMissedDeliveryErrorToast={setDeliveryDoneByAnotherDriver} message={delveryDoneByAnotherDriver} />}

				</div>

				{
					showConfirmationModal &&
					<RouteConfirmation
						setShowConfirmationModal={setShowConfirmationModal}
						showConfirmationModal={showConfirmationModal}
						pharmacyId={pharmacyId} />
				}


				{
					missedDeliveryConfirmation &&
					<MissedDeliveryConfirmation
						setShowConfirmationModal={setMissedDeliveryConfirmation}
						showConfirmationModal={missedDeliveryConfirmation}
						pharmacyId={pharmacyId}
						handleMissedDelivery={handleMissedDelivery}
						missedData={missedData}
						missedExplanation={missedExplanation}
						setMissedExplanation={setMissedExplanation}
						missedExplanationError={missedExplanationError}
						setMissedExplanationError={setMissedExplanationError}
						isSubmitting={updateDeliveryListResponse?.loading}
					/>
				}

			</div>

			<RoutePharmacistModal
				showModel={showModel}
				setShowModel={setShowModel}
				isDelivered={false} route={selectedRoute} />
			<RouteControlSheet
				isOpen={showRouteHandover}
				onClose={() => setShowRouteHandover(false)}
				requestedTab={TAB.HANDOVER}
				initialHandoverRoute={selectedRoute}
			/>


			<TodayDispenseDeliveredByAnotherDriverAblyHelper
				apiKey={apiKey}
				deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
				pharmacyId={pharmacyId}
				driverID={driverID}
				pId={pId}
				routeName={routeName}
				location={location}
				setPatientID={setPatientID}
				setDeliveryDoneByAnotherDriver={setDeliveryDoneByAnotherDriver}
				dispatch={dispatch}
				removeTodayDispenePatientById={removeTodayDispenePatientById}
				setOpenIndex={setOpenIndex}
				setPId={setPId}
				setCordinate={setCordinate}
			/>

			{/* <FlexiRxStatusWarningModal
				rxNumbers={flexiRxNumbers}
				showModal={showFlexiConfirmation}
				setShowModal={setShowFlexiConfirmation}
			// onConfirm={() => handleConfirmDelivery(patientsData)}
			// onCancel={() => setShowFlexiConfirmation(false)}
			/> */}


		</>
	)
}

export default TodayDispense
